<template lang="pug">
  .zip-search
    .zip-header
      .row
        .col-sm-4.col-md-3
          .form-group
            label Store Zip Code {{ labelNumber }}
            input.form-control.zip(:value="zipcode" @input="$emit('update:zipcode', $event.target.value)" @focus="hasFocus = true" @blur="hasFocus = false")
      .row(v-show="hasFocus || searchStores.length > 0")
        .col
          strong {{ count }} store{{ count === 1 ? '' : 's'}} selected. You may select {{ 10 - count }} more stores.
    .zip-table(v-show="searchStores.length > 0")
      Datatable(:footer="false" :entries="searchStores")
        template(slot="header")
          th.h6 Store Name
          th.h6 Address
          th.h6 Phone
          th.h6 County
        template(slot-scope="props")
          tr
            td.body-2
              CustomCheckbox(
                :value="value.includes(props.entry.pharmacySid)"
                @input="changeStores(props.entry.pharmacySid)"
              )  {{ props.entry.pharmacyName }}
            td.body-2 {{ props.entry.address1 }}{{ props.entry.address2 ? ', ' + props.entry.address2 : '' }}, {{ props.entry.city }}, {{ props.entry.stateCd }} {{ props.entry.postalCode }}
            td.body-2 {{ props.entry.phone }}
            td.body-2 {{ props.entry.countyName }}
</template>

<script>
import Datatable from '@/components/Datatable'
import CustomCheckbox from '@/components/CustomCheckbox'
import axios from '@/lib/axios'
import { globalError, toggle } from '@/lib/utils'

export default {
  name: 'ZipSearch',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    zipcode: {
      type: String,
      default: '',
    },
    searchStores: {
      type: Array,
      default: () => [],
    },
    labelNumber: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      hasFocus: false,
    }
  },
  methods: {
    toggle,
    changeStores(pharmacySid) {
      if (!this.value.includes(pharmacySid) && this.count >= 10) return
      toggle(this.value, pharmacySid)
      this.$emit('input', this.value)
    },
  },
  components: {
    Datatable,
    CustomCheckbox,
  },
}
</script>

<style lang="scss" scoped>
.zip-header {
  border: 1px solid #e6e6e6;
  padding: 1rem;
}

.zip-table {
  max-height: 300px;
  overflow-y: scroll;
  border-bottom: 1px solid #e6e6e6;
}
</style>
